import { render, staticRenderFns } from "./StrokedButton.vue?vue&type=template&id=e24c93ac&"
import script from "./StrokedButton.vue?vue&type=script&lang=js&"
export * from "./StrokedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports